import MockAdapter from 'axios-mock-adapter'
import { get } from 'lodash'
import Config from '@/config'
import Setup from './setup'
import { normalizeMocks } from './utils'

let mock = null

const mocks = {}
export const defaultResponses = {}

const generateMockData = ({ name, endpoints }) => {
    if (!mock) {
        console.warn(`[MockResponse] Mock is not initialized.`)
        return
    }
    const { mocks: mocksObject, defaultResponses: defaultResponsesObject } = normalizeMocks(endpoints)
    if (!name || !mocks || !defaultResponses) {
        console.warn(`[MockResponse] Mock has not exists.`)
        return
    }
    mocks[name] = {}
    defaultResponses[name] = {}
    Object.keys(mocksObject).forEach((key) => {
        if (!defaultResponsesObject[key]) {
            console.warn(`[MockResponse] Mock item has no response by default.`)
            return
        }
        mocks[name][key] = mocksObject[key](mock)
        defaultResponses[name][key] = defaultResponsesObject[key]
    })
}

export const mockResponse = (key, response) => {
    if (!key) {
        console.warn(`[MockResponse] Key is required.`)
        return null
    }
    const mockInstance = get(mocks, key)
    if (!mockInstance) {
        console.warn(`[MockResponse] The key '${key}' has no mock.`)
        return null
    }
    if (response) {
        const [status, data] = response
        return mockInstance.reply(status, data)
    }
    const defaultResponse = get(defaultResponses, key)
    if (!defaultResponse) {
        console.warn(`[MockResponse] The key '${key}' has no response by default.`)
        return null
    }
    return defaultResponse(mockInstance)
}

/**
 * axios 0.33 hands the adapter a `config.headers` built with a null prototype,
 * so `config.headers.constructor` is undefined and axios-mock-adapter blows up
 * on its `constructor.name === 'AxiosHeaders'` check. Give the object a normal
 * prototype right before the mock adapter sees it. Mocks only run under test or
 * VUE_APP_USE_MOCK, so this never touches a real request.
 */
const withPlainHeaders = (axios) => {
    const mocked = axios.defaults.adapter
    // eslint-disable-next-line no-param-reassign
    axios.defaults.adapter = (config) => {
        if (config.headers && Object.getPrototypeOf(config.headers) === null) {
            // eslint-disable-next-line no-param-reassign
            config.headers = Object.assign({}, config.headers)
        }
        return mocked(config)
    }
}

export default (axios) => {
    // This sets the mock adapter on the default instance
    mock = new MockAdapter(axios, { delayResponse: !Config.isTest ? 500 : 0 })
    withPlainHeaders(axios)

    // Init mocks
    Setup.mocks.map(generateMockData)

    if (!Config.isTest) {
        // Init default responses
        Setup.endpoints.map(e => mockResponse(e))
        mock.onAny().passThrough()
    }
}
